export default function formatNumberWithDecimal(number: number) {
  const strung = number.toFixed(1);

  if (strung.endsWith('.0')) {
    return strung.slice(0, -2);
  }

  return strung;
}
